import React from "react";
import { useLang } from "../i18n";
import { LEGAL } from "../data/content";
import { LegalLayout } from "../components/LegalLayout";

export default function Cookies() {
  const { lang } = useLang();
  return (
    <LegalLayout
      label="Cookies"
      title={lang === "ro" ? "Politica de Cookies" : "Cookie Policy"}
      sections={LEGAL.cookies}
    />
  );
}
